export class MessageEndpointLinkModel {
  _id?: any;
  uuid: string;
  msg_uuid: string;
  endpoint_uuid: string;
  contact_agent_uuid: string;
  revision: string;
  status: string;
  vrsn: string;
  is_read: boolean;
  is_deleted: boolean;
  msg_status: string;
  status_date: Date;
  create_date?: Date;
  update_date?: Date;
  created_by?: string;
  updated_by?: string;
  property_json?: any;
}
